import { Stack } from "@mantine/core";
import type { UseFormReturn } from "react-hook-form";
import { FormFieldController } from "../../../BuildingBlocks/Forms/Controllers/FormFieldController";
import { GENERATOR_FORM_DATA } from "../GeneratorModal.constants";
import type { GeneratorSingleEndpointResponse } from "../GeneratorModal.types";

interface PriceDataTabProps {
  generatorForm: UseFormReturn<GeneratorSingleEndpointResponse>;
}

function PriceDataTab({ generatorForm }: PriceDataTabProps) {
  const { control } = generatorForm;

  return (
    <Stack gap={0}>
      <FormFieldController
        control={control}
        data={GENERATOR_FORM_DATA.feedin_tariff_deprecated}
      />
      <FormFieldController
        control={control}
        data={GENERATOR_FORM_DATA.feedin_tariff_non_pv}
      />
      <FormFieldController
        control={control}
        data={GENERATOR_FORM_DATA.applicable_value_pv}
      />
      <FormFieldController
        control={control}
        data={GENERATOR_FORM_DATA.market_value_eeg}
      />
      <FormFieldController
        control={control}
        data={GENERATOR_FORM_DATA.direct_marketing_fee}
      />
      <FormFieldController
        control={control}
        data={GENERATOR_FORM_DATA.own_consumption_subsidy}
      />
      <FormFieldController
        control={control}
        data={GENERATOR_FORM_DATA.kwkg_direct_delivery_subsidy}
      />
    </Stack>
  );
}

export { PriceDataTab };
